/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu June 15 2021 14:30:00 PM
 *
 *******************************************************/
//flow
import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Banner, TextStyle } from '@shopify/polaris';
import { getShop } from 'src/helpers';
import { FEATURE_IDS } from 'src/constants/theme-upgrade';

type Props = {
  featureID: String,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

const Condition3Notification: React.FC<ComposedProps> = ({ featureID, emailSupport, i18n }) => {
  let t1 = '';
  switch (featureID) {
    case FEATURE_IDS.SEARCH_PAGE_DISPLAY:
      t1 = (
        <TextStyle variation="strong">
          {i18n.translate(
            'AdminHTML.Common.ThemeUpgradeFlow2Notification.content1_t1_SearchPageDisplay'
          )}
        </TextStyle>
      );
      break;
    case FEATURE_IDS.ANALYTICS:
      t1 = (
        <TextStyle variation="strong">
          {i18n.translate('AdminHTML.Common.ThemeUpgradeFlow2Notification.content1_t1_Analytics')}
        </TextStyle>
      );
      break;
    case FEATURE_IDS.INTEGRATION:
      t1 = (
        <TextStyle variation="strong">
          {i18n.translate('AdminHTML.Common.ThemeUpgradeFlow2Notification.content1_t1_Integration')}
        </TextStyle>
      );
      break;
    case FEATURE_IDS.SWATCH_SETTINGS:
      t1 = (
        <TextStyle variation="strong">
          {i18n.translate(
            'AdminHTML.Common.ThemeUpgradeFlow2Notification.content1_t1_SwatchSettings'
          )}
        </TextStyle>
      );
      break;
    case FEATURE_IDS.SORT_BY_OPTIONS:
      t1 = (
        <TextStyle variation="strong">
          {i18n.translate(
            'AdminHTML.Common.ThemeUpgradeFlow2Notification.content1_t1_SortByOptions'
          )}
        </TextStyle>
      );
      break;
    default:
      break;
  }

  const handleAction = () => {
    const shop = getShop();

    window.top.location.href = `https://${shop}/admin/themes`;
  };

  return (
    <Banner
      status="warning"
      title={i18n.translate('AdminHTML.Common.ThemeUpgradeFlow2Notification.title1')}
      action={{
        content: i18n.translate('AdminHTML.Common.ThemeUpgradeFlow2Notification.actionLabel'),
        onAction: handleAction
      }}>
      <p>
        {i18n.translate('AdminHTML.Common.ThemeUpgradeFlow2Notification.content1', {
          t1,
          t2: (
            <TextStyle variation="strong">
              {i18n.translate(
                'AdminHTML.Common.ThemeUpgradeFlow2Notification.content1_t2_PublishYourTheme'
              )}
            </TextStyle>
          )
        })}
      </p>
      <br />
      <p>
        {i18n.translate('AdminHTML.Common.ThemeUpgradeFlow2Notification.content2', {
          nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
        })}
      </p>
    </Banner>
  );
};

export default withI18n()(Condition3Notification);
